import React from 'react';
import loadable from '@loadable/component';
import { showPriceCredits } from '../../helpers/price';
import { RESERVATION_TYPE } from '../../consts/reservation.consts';
import { formatRating, formatReviewCount } from '../../helpers/rating';
import SniffButton from '../../components/sniff-button';
import SvgStarSolid from 'src/assets/svg/SvgStarSolid.svg';

const RenderInactive = loadable(() => import('./render-inactive'));

const DesktopBookBlock = ({ spot, handleBook, useState, isRecentReviewsTest }) => {
    const parsedPrice = showPriceCredits(spot.price);

    // Get the appropriate rating based on the test
    const effectiveRating = isRecentReviewsTest ? spot.effectiveRatingV2 || spot.rating : spot.rating;

    return (
        <div>
            {spot.live && spot.host?.id > 0 ? (
                <>
                    <p className="snif-m2 snif-medium mb-2">Book this spot!</p>
                    <div className="book-price mb-3">
                        <p>
                            <span className="price snif-m1 snif-semibold">{parsedPrice}</span>
                            <br />
                            per dog per hour
                        </p>
                        <div className="book-rating">
                            {effectiveRating ? (
                                <>
                                    <SvgStarSolid className="star-icon" />
                                    <div className="ratings-count">{formatRating(effectiveRating)}</div>
                                    <div className="comments-count">{`(${formatReviewCount(spot.reviewsCount)})`}</div>
                                </>
                            ) : (
                                <span className="new">New!</span>
                            )}
                        </div>
                    </div>
                    <SniffButton className="mb-2" size="lg" block onClick={() => handleBook(RESERVATION_TYPE.BOOK)}>
                        Book now
                    </SniffButton>
                    <SniffButton
                        color="secondary"
                        size="lg"
                        block
                        disabled={!spot.live || spot.host?.id == 0}
                        onClick={() => handleBook(RESERVATION_TYPE.CALENDAR)}
                    >
                        Find an available time
                    </SniffButton>
                </>
            ) : (
                <RenderInactive {...{ spot, useState }} />
            )}
        </div>
    );
};

export default DesktopBookBlock;
